import React from "react"

export default function Star() {
  return (
    <symbol id="svg-select-star" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M29.7,12.5c-0.1-0.2-0.3-0.3-0.6-0.3h-9.9l-3.1-9.4c-0.1-0.4-0.5-0.6-0.9-0.4c-0.2,0.1-0.4,0.2-0.4,0.4l-3.1,9.4H1.9  c-0.4,0-0.7,0.3-0.7,0.7c0,0.2,0.1,0.4,0.3,0.6l8,5.8l-3.1,9.4c-0.1,0.2,0,0.4,0,0.5c0.1,0.2,0.2,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0  s0.3,0,0.4-0.1l8-5.8l8,5.8c0.3,0.2,0.7,0.2,1-0.2c0.1-0.2,0.2-0.4,0.1-0.6l-3-9.3l8-5.8C29.8,13.3,29.9,12.8,29.7,12.5z M11,19.3  c0.1-0.3,0-0.6-0.3-0.8L4,13.6h8.3l0,0c0.3,0,0.6-0.2,0.7-0.5l2.5-7.8l2.6,7.9c0.1,0.3,0.4,0.5,0.7,0.5l0,0h8.3l-6.7,4.9l0,0  c-0.2,0.2-0.3,0.5-0.3,0.8l2.6,7.9L16,22.4c-0.1-0.1-0.3-0.1-0.4-0.1s-0.3,0-0.4,0.1l-6.7,4.9L11,19.3z"
      />
    </symbol>
  )
}
